import type { ProductRelationDetail } from '@repositories/productsRelationsRepository/productRelations.types';
import { SoftwareSimpleModel } from './SoftwareSimpleModel';

export class ProductRelationDetailModel {
  private readonly _dto: ProductRelationDetail;

  constructor(dto?: ProductRelationDetail) {
    this._dto = dto || {} as ProductRelationDetail;
  }

  get originDTO(): ProductRelationDetail {
    return this._dto;
  }

  public get productId(): string {
    return this._dto.productId || '';
  }

  public get iconUrl(): string {
    return this._dto.iconUrl || '';
  }

  public get thumbnailUrl(): string {
    return this._dto.thumbnailUrl || '';
  }

  public get name(): string {
    return this._dto.name || '';
  }

  public get description(): string {
    return this._dto.description || '';
  }

  public get categoryName(): string {
    return this._dto.categoryName || '';
  }

  public get type(): 'RELATED' | 'RECOMMEND' | '' {
    return this._dto.type ?? '';
  }

  public get categoryNameList(): string[] {
    return this.categoryName.split(',');
  }

  public get simpleModel(): SoftwareSimpleModel {
    return new SoftwareSimpleModel({
      id: this._dto.productId || '',
      name: this._dto.name || '',
      productCode: '',
      iconUrl: this._dto.iconUrl || '',
      thumbnailUrl: this._dto.thumbnailUrl || '',
      description: this._dto.description || '',
      planVisibilityScope: 'ALL_USERS',
    });
  }
}
